import { Skeleton, TableCell, TableRow } from '@mui/material';
import React from 'react';

const ProjectsListSkeleton = (props) => {
    const style = {
        margin: '.25rem 0',
    };

    return (
        <React.Fragment>
            <TableRow key="tr-skeleton-1">
                <TableCell>
                    <Skeleton
                        animation="wave"
                        height={15}
                        width="60%"
                        style={style}
                    />
                </TableCell>
            </TableRow>
            <TableRow key="tr-skeleton-2">
                <TableCell>
                    <Skeleton
                        animation="wave"
                        height={15}
                        width="80%"
                        style={style}
                    />
                </TableCell>
            </TableRow>
            <TableRow key="tr-skeleton-3">
                <TableCell>
                    <Skeleton
                        animation="wave"
                        height={15}
                        width="60%"
                        style={style}
                    />
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
};

export default ProjectsListSkeleton;
